import { render, staticRenderFns } from "./PFAwatingSettlementListFront.vue?vue&type=template&id=2a214923"
import script from "./PFAwatingSettlementListFront.vue?vue&type=script&lang=js"
export * from "./PFAwatingSettlementListFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports